import { Box, Card, Chip, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const GlobalWebhookDetails = ({ webhook, onOpenMenu }) => {
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <Typography fontWeight={600} fontSize={22} sx={{ color: '#fff' }}>
          Global Webhook Details
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{ border: '1px solid #374151', p: 0.75, mr: 1, borderRadius: 1 }}
          >
            {webhook.active ? (
              <>
                <CheckCircleIcon sx={{ color: '#22c55e', fontSize: 18 }} />
                <Typography variant="body2" color="#22c55e">
                  Active
                </Typography>
              </>
            ) : (
              <>
                <CancelIcon sx={{ color: '#94a3b8', fontSize: 18 }} />
                <Typography variant="body2" color="#94a3b8">
                  Inactive
                </Typography>
              </>
            )}
          </Stack>
          <IconButton size="small" onClick={(e) => onOpenMenu(e)}>
            <MoreHorizIcon sx={{ color: '#ffffff' }} />
          </IconButton>
        </Box>
      </Box>

      <Box sx={{ width: '100%' }}>
        <Box sx={{ mt: 2, mb: 2 }}>
          <Typography>{webhook.name}</Typography>
          <Typography>{webhook.url}</Typography>
        </Box>
        {webhook.event_types.map((event_type) => (
          <Chip
            key={event_type}
            label={event_type}
            size="small"
            sx={{
              backgroundColor: 'grey.900',
              color: '#e5e7eb',
              border: '1px solid #374151',
              borderRadius: 1,
              m: 0.25,
            }}
          />
        ))}
      </Box>
    </>
  );
};

export default GlobalWebhookDetails;
